import {Pipe, PipeTransform} from '@angular/core';
import { Constants } from 'src/app/shared/utils/constants';
@Pipe({name: 'operatorsPipe'})
export class OperatorsPipe implements PipeTransform {
    transform(value: any): string {
        const obj = Constants.OPERATORS.find(x => x.value === value);
        if (obj !== null) {
            return obj.text;
        }
    }
}